import React, { useState } from "react";
import {
  Box,
  Container,
  Divider,
  Link,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import ReactCountryFlag from "react-country-flag";
import Fi from "../Field/Fi";
import Button from "../Button/Button";
import Modal from "@mui/material/Modal";
import FacebookIcon from "../../../assets/images/facebookIcon.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import GoogleIcon from "../../../assets/images/googleIcon.png";
import Machine1 from "../../../assets/images/machine1.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EmailIcon from "../../../assets/images/emailIcon.png";
import SocialButtons from "../SocialButtons/SocialButtons";

function LoginModalPLP({ open, setOpen, children }) {
  const [ForgotPass, setForgotPass] = useState(false);
  const [CreateAcc, setCreateAcc] = useState(false);
  const mobMatch = useMediaQuery("(max-width:600px)");
  const handleClose = () => setOpen(false);
  const CreateAccountForm = () => {
    return (
      <Box>
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "600",
            marginBottom: "16px",
          }}
        >
          Create new account
        </Typography>
        <Box>
          <Fi
            label="Full Name"
            size="small"
            height="48px"
            sx={{ marginBottom: "24px", maxWidth: "336px" }}
          />
          <Fi
            label="Email address"
            size="small"
            height="48px"
            sx={{ marginBottom: "24px", maxWidth: "336px" }}
          />
          <Box
            sx={{
              marginBottom: "24px",
              display: "flex",
              width: "336px",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "85px",
                height: "47.4px",
                backgroundColor: "#F5F5F5",
                border: "1px solid #BFBFBF",
                borderRight: "none",
                borderRadius: "3px 0 0 3px",
              }}
            >
              <ReactCountryFlag countryCode="AE" svg />
              <Typography
                variant="body1"
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="400"
                lineHeight="24px"
                color="primary.main"
                sx={{ marginLeft: "5px" }}
              >
                +971
              </Typography>
            </Box>
            <Fi
              sx={{
                width: "251px",
                height: "46.29px",
              }}
              inputPropsSx={{
                borderRadius: "0 3px 3px 0",
              }}
              label="Phone Number"
              size="small"
              height="48px"
            />
          </Box>
          <Fi
            label="Company Name"
            size="small"
            height="48px"
            sx={{ marginBottom: "24px", maxWidth: "336px" }}
          />
          <Fi
            label="Password"
            size="small"
            height="48px"
            sx={{ marginBottom: "24px", maxWidth: "336px" }}
          />
          <Fi
            label="Confirm Password"
            size="small"
            height="48px"
            sx={{ marginBottom: "24px", maxWidth: "336px" }}
          />

          <FormControlLabel
            sx={{ alignItems: "start", display: "flex", margin: "0px" }}
            control={
              <Checkbox sx={{ width: "24px", height: "24px" }} defaultChecked />
            }
            label={
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", lineHeight: "20px" }}
              >
                Check here to indicate that you have read and agree to the terms
                and conditions of the{" "}
                <a
                  href="?"
                  style={{ color: "#255CCE", textDecoration: "none" }}
                >
                  Machinery Planet's Pro agreement.
                </a>
              </Typography>
            }
          />

          <Button
            bgColor="#F9D548"
            txColor="text.primary"
            typoVariant="subtitle1"
            typoSize="16px"
            fontWeight="600"
            hoverBg="#F3C04F"
            sx={{
              marginTop: "24px",
              width: "100%",
              height: "48px",
              maxWidth: "336px",
              marginBottom: "24px",
            }}
          >
            Register
          </Button>
        </Box>
      </Box>
    );
  };

  console.log(open);
  return (
    <Modal
      sx={{ width: "100vw", background: "#fff", overflow: "scroll" }}
      hideBackdrop={true}
      open={open}
      onClose={handleClose}
    >
      <Box sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingX: "28px",
            height: "71px",
            width: "100%",
            borderBottom: "1px solid #D6D6D6",
          }}
        >
          <ArrowBackIcon
            sx={{ cursor: "pointer", color: "primary.main" }}
            onClick={() => handleClose()}
          />
        </Box>
        <Container disableGutters={true}>
          <Box
            sx={{
              paddingTop: "32px",
            }}
          >
            <Typography
              variant="h3"
              sx={{ fontSize: "22px", fontWeight: "600", lineHeight: "26px" }}
            >
              Login to continue
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                color: "#616161",
                marginTop: "8px",
              }}
            >
              So we can keep you up-to-date with your purchase.
            </Typography>
          </Box>
          <Container
            sx={{
              display: "flex",
              marginTop: "32px",
              columnGap: "96px",
              paddingBottom: "117px",
            }}
            disableGutters={true}
          >
            <Box
              sx={{
                display: "flex",
                columnGap: "48px",
              }}
            >
              {!CreateAcc ? (
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: "600",
                      marginBottom: "16px",
                    }}
                  >
                    {ForgotPass
                      ? "Forgot Password?"
                      : "Already have an account?"}
                  </Typography>
                  <Box>
                    <Fi
                      label="Email Address"
                      size="small"
                      height="48px"
                      sx={{ marginBottom: "24px", maxWidth: "336px" }}
                    />
                    {!ForgotPass ? (
                      <Fi
                        label="Password"
                        size="small"
                        height="48px"
                        sx={{ marginBottom: "24px", maxWidth: "336px" }}
                      />
                    ) : (
                      ""
                    )}
                    <Button
                      bgColor="#F9D548"
                      txColor="text.primary"
                      typoVariant="subtitle1"
                      typoSize="16px"
                      fontWeight="600"
                      hoverBg="#F3C04F"
                      sx={{
                        width: "100%",
                        height: "48px",
                        maxWidth: "336px",
                        marginBottom: "24px",
                      }}
                    >
                      {ForgotPass ? "Send instructions" : "Login"}
                    </Button>
                    <Link
                      onClick={() => {
                        setForgotPass(!ForgotPass);
                      }}
                      sx={{ cursor: "pointer" }}
                      underline="none"
                      color="#255CCE"
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          fontWeight: "600",
                        }}
                      >
                        {ForgotPass ? "Back to Login" : "Forgot password?"}
                      </Typography>
                    </Link>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexFlow: "column",
                      rowGap: "24px",
                      marginTop: "24px",
                    }}
                  >
                    <SocialButtons
                      icon={FacebookIcon}
                      text="Login with Facebook"
                    />
                    <SocialButtons
                      icon={GoogleIcon}
                      text="Sign In with Google"
                    />
                  </Box>
                </Box>
              ) : (
                ""
              )}

              {!CreateAcc && (
                <Box
                  sx={{ width: "1px", borderLeft: "1px solid #D6D6D6" }}
                ></Box>
              )}
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "600",
                    marginBottom: "16px",
                  }}
                >
                  Create new account
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexFlow: "column",
                    rowGap: "24px",
                  }}
                >
                  <SocialButtons
                    onClick={() => {
                      setCreateAcc(!CreateAcc);
                    }}
                    icon={FacebookIcon}
                    text="Login with Facebook"
                  />
                  <SocialButtons icon={GoogleIcon} text="Sign In with Google" />
                  <SocialButtons
                    imgStyle={{ height: "18px" }}
                    icon={EmailIcon}
                    text="Register using Email"
                  />
                </Box>
              </Box>
              {CreateAcc && (
                <Box
                  sx={{ width: "1px", borderLeft: "1px solid #D6D6D6" }}
                ></Box>
              )}
              {CreateAcc && <CreateAccountForm />}
            </Box>
            {children}
          </Container>
        </Container>
      </Box>
    </Modal>
  );
}

export default LoginModalPLP;
